/* eslint-disable @nx/enforce-module-boundaries */
import { RankingQuestionConfig } from '@hyper-inferno/click-to-rank-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';

export class ClickToRankHandler
  implements QuestionHandler<RankingQuestionConfig>
{
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options
    );

    return {
      ...el.config,
      options,
    };
  }
}
